import React from 'react';
import Navbar from "../components/Navbar";
import './code.css'

function Code() {
  return (
    <div>
      <Navbar />
      <h1 className="header" style={{ fontFamily: 'Cormorant SC, serif', fontSize: '3.5rem' }}>Game Development & Design</h1>
      <hr className="line"/>
      <div className="collectionTitle">
        <h1>Jamnesia</h1>
        <div className="collection_container">
          <img src="images/codePortfolio/Jamnesia/jamnesia.png" alt="Jamnesia"/>
          <div className="description_container">
            <p1>Fiat Ludum 2025 | First Place + Best Visuals</p1>
            <p2>Presented by ASUS Republic of Gamers</p2>
            <p>Worked in a team of four to develop a game in under 72 hours, based on the theme “Begin Anew”.</p>
            <p>Welcome to James’s jam shop! Follow a local jam-maker as he collects unusual ingredients for his recipes. But be careful! We don’t know what the side effects are…</p>
            <a href="https://jadonz.itch.io/jamnesia" target="_blank" rel="noopener noreferrer">
              <button>PLAY THE GAME</button>
            </a>
          </div>
        </div>
      </div>

      <hr className="line"/>
      <div className="collectionTitle">
        <h1>Reminiscence</h1>
        <div className="collection_container">
          <img src="images/codePortfolio/Reminiscence/reminiscence.png" alt="Reminiscence"/>
          <div className="description_container">
            <p3>Reminiscence is a platforming puzzle game developed in Unity.</p3>
            <p>Worked in a team of four to design, plan, and program a game during an academic quarter.</p>
            <p>You are in a shattered world. You have the ability to view glimpses of the past and must use this ability to traverse obstacles. While you explore, you slowly piece together what brought about the world’s downfall.</p>
            <a href="https://ashen75.itch.io/reminiscence" target="_blank" rel="noopener noreferrer">
              <button>PLAY THE GAME</button>
            </a>
          </div>
        </div>

      </div>



{/* Footer */}
      <div className="footer__container">
        <div className="websiteRights">
          <p>© MINYA 2025 | all rights reserved</p>
        </div>
      </div>

    </div>
  );
}

export default Code;
